export function scrollBody(scroll: boolean) {
  if (!scroll) document.body.classList.add('noscroll');
  else document.body.classList.remove('noscroll');
}
